export default __webpack_public_path__ + "static/media/gi.a87ba99e.svg";